<template>
    <div>
        <div class="field has-addons">
            <div class="control time-period-con">
                <input
                    class="input"
                    :class="{ 'is-danger' : errors.has(formName) }"
                    :name="formName"
                    v-model="localValue.value"
                    v-validate="'required|integer'"
                    :placeholder="selectedOption.label"
                    @keypress.enter="$emit('enter')"
                />

            </div>
            <div class="control">
                <div class="select">
                    <select
                        v-model="localValue.time"
                        :name="timeFormName"
                        @change="setSelectedOption"
                    >
                        <option
                            v-for="v in timeOptions"
                            :key="v.value"
                            :value="v.value"
                        >
                            {{v.label}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div
            class="error-message"
            v-show="errors.has(formName)"
        >
            You must enter a valid integer number of {{selectedOption.label}}
        </div>
    </div>
</template>

<script>
export default {
    name : "Timestamp",
    inject : ['$validator'],
    data () {
        return {
            timeOptions : [
                { value : 'minute', label : 'Minutes' },
                { value : 'hour', label : 'Hours' },
                { value : 'day', label : 'Days' },
                { value : 'month', label : 'Month' },
            ],
            selectedOption : null,
        };
    },
    props : {
        value : {
        },
        formName : {
            type : String,
            required : true,
        },
    },
    beforeMount () {
        this.ensureTimeSelected();
        this.setSelectedOption();
    },
    beforeUpdate () {
        this.ensureTimeSelected();
        this.setSelectedOption();
    },
    computed : {
        localValue : {
            get () { return this.value; },
            set (localValue) { this.$emit('input', localValue ); }
        },
        timeFormName () {
            return `time-${this.formName}`;
        },
    },
    methods : {
        ensureTimeSelected () {
            if(!this.localValue.time){
                //default to days
                this.localValue.time = this.timeOptions[2].value;
            }
        },
        setSelectedOption () {
            this.selectedOption = this.timeOptions.find(t => t.value === this.value.time);
        },
        getLabel () {
            return `${this.value.value} ${this.selectedOption.label}`;
        },
    },
}
</script>

<style lang="scss" scoped>
    .field.has-addons {
        margin-bottom:0 !important;
    }
    .time-period-con {
        max-width:75px;
        input {
            text-align:center;
        }
    }
</style>
